import { ButtonBase, Tooltip, Typography } from "@mui/material";
import { useEffect, useState, useRef } from "react";

const SwitchBox = (props) => {
  const { title = "", tabs, info, activeTabIndex, value } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tooltipRef = useRef();

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setTooltipOpen(false);
    }
  };
  const handleInfoIconClick = (event) => {
    event.stopPropagation();
    setTooltipOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setTabIdx(typeof activeTabIndex === "undefined" ? 0 : activeTabIndex);
  }, [tabs, activeTabIndex]);

  let infoText = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <ul className="pl-[15px]">
        <li className="list-disc">Very High (81 - 100%)</li>
        <li className="list-disc">High (71 - 80%)</li>
        <li className="list-disc">Normal (60 - 70%)</li>
      </ul>
      <p className="my-[7px]">
        *LTV Approval is for reference only and on a case-to-case basis. LTV
        Approval above 80% may include Rental, Private Hire Loan nad
        Lease-to-own loan packages
      </p>
    </div>
  );
  let infoText2 = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <ul className="pl-[15px]">
        <li className="list-disc">Instant &lt; 30 Minutes</li>
        <li className="list-disc">Fast &lt; 2 Working Days</li>
        <li className="list-disc">Very Fast &lt; 1 Working Day</li>
      </ul>
      <p className="my-[7px]">
        *Approval Time is for reference only and on straightforward loan cases.
        Approval Time is calculated based on the time needed to approve or
        reject a loan application submission
      </p>
    </div>
  );
  let tootipText = "";
  if (title === "Approval Time") {
    tootipText = infoText2;
  } else if (title === "Loan to Value") {
    tootipText = infoText;
  } else {
    tootipText = "coming soon";
  }
  const handleSwitch = (idx, tabId) => {
    setTabIdx(idx);
    if (props.settingsHandle && title) {
      let titleName = title.toLowerCase();
      if (titleName === 'category') {
        titleName = 'type';
      } else if (titleName === 'type') {
        titleName = 'category';
      }
      props.settingsHandle(idx, titleName, tabId);
    }
    // //console.log("==",props.settingsHandle)
  };
  return (
    <div className={`switch_tab mr-[20px] mb-[15px] inline-block`}>
      {title ? (
        <label className="text-[13px] text-[#878B91] mb-[10px] inline-flex items-center">
          {title}
          {info && (
            <Tooltip open={tooltipOpen} title={tootipText}>
              <img
                src="/images/fi_info.svg"
                alt="info"
                onClick={handleInfoIconClick}
                className="inline-block ml-[8px] cursor-pointer"
              />
            </Tooltip>
          )}
        </label>
      ) : null}
      <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex" ref={tooltipRef}>
        {tabs.map((tab, idx) => {
          // //console.log("SWITCH", value, tab?.id);
          return (
            <ButtonBase
              disableRipple={!!tab?.disabled}
              key={idx}
              disabled={tab?.disabled ? true : false}
            >
              <span
                className={`switch ${value === tab?.id && "active"} ${tab?.disabled ? "opacity-40" : ""
                  }`}
                onClick={() => handleSwitch(idx, tab.id)}
              >
                {tab?.name}
              </span>
            </ButtonBase>
          );
        })}
      </div>
    </div>
  );
};

export default SwitchBox;
